/**
 * The first line of something the coach wrote, as plain text — "Three sets of
 * ten off the tee, outer third…" — for a row that has room for one line.
 *
 * Each list item, paragraph and line break is a line of its own, so a numbered
 * plan gives its first step rather than every step run together. An ellipsis
 * says there is more. Parsed with DOMParser, which runs nothing it reads.
 */
export function firstLine(html: string): string {
  const body = new DOMParser().parseFromString(html, 'text/html').body;
  for (const code of [...body.querySelectorAll('script, style, template, noscript')]) code.remove();
  for (const br of [...body.querySelectorAll('br')]) br.replaceWith('\n');
  for (const block of [...body.querySelectorAll('li, p, div')]) block.append('\n');

  const lines = (body.textContent ?? '')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

  if (lines.length === 0) return '';
  return lines.length > 1 ? `${lines[0]}…` : (lines[0] ?? '');
}
